import { forwardRef, type Ref, type SVGProps } from "react";
const IconSchoolAlternateFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.6 11.56 17 7.14a3.44 3.44 0 0 0-2 0L2.42 11.56c-.54.19-.54.5 0 .69l13.29 4.66a.5.5 0 0 1 .3.64l-.36 1a.49.49 0 0 1-.64.3L8 16.38v4.12a2.6 2.6 0 0 0 .22.95S10 25 16 25s7.78-3.55 7.78-3.55a2.6 2.6 0 0 0 .22-.95v-6.29l2-.7V21a1 1 0 0 0 2 0v-8.19l1.6-.56c.53-.19.53-.5 0-.69M15.93 13c-.83 0-1.5-.45-1.5-1s.67-1 1.5-1 1.5.45 1.5 1-.67 1-1.5 1" />
  </svg>
);
const ForwardRef = forwardRef(IconSchoolAlternateFilledSVG);
ForwardRef.displayName = "IconSchoolAlternateFilled";
export { ForwardRef as IconSchoolAlternateFilled };
